import React from 'react'
import product from './product/config'
import category from './category/config'
import user from './user/config'
import media from './media/config'
import options from './options/config'
import creditClient from './creditClient/config'
import loyaltyCard from './loyaltyCard/config'
import closing from './closing/config'
import statistic from './statistics/config'
import message from './message/config'
import cashBook from './cashBook/config'
import { isRouteDisabled } from './utils'
import * as icons from 'media/icons'
import { Monitor, YellowRightArrow } from 'media/icons'
import { version } from '../../package.json'
import styled from 'styled-components'

const sectionsFuncArray = [
	product,
	category,
	user,
	media,
	creditClient,
	closing,
	cashBook,
	loyaltyCard,
	statistic,
	message,
	options,
	(_, rights) => ({
		icon: Monitor,
		name: 'Dashboard',
		label: 'Dashboard',
		linkDisabled: isRouteDisabled(rights, '99'),
		NavAction: () => {
			window.location.href = 'https://dashboard.hssoft.com'
		}
	})
]

const StyledLink = styled.a`
	display: flex;
	align-items: center;
	gap: 10px;
	text-decoration: none;
	font-size: 16px;
	white-space: nowrap;
	color: #F9CB37;

	svg {
		margin: 0;
	}
`

export const getBottomSections = ({ signOut, companyName, t }) => [
	{
		className: 'bottomnav-logo',
		icon: icons.LogoHorizontal,
		name: version
	},
	...(companyName ? [{
		className: 'bottomnav-company',
		name: companyName
	}] : []),
	{
		className: 'bottomnav-switch-ui',
		Component: () => (<StyledLink href={`${import.meta.env.VITE_NEW_APP_URL}${window.location.pathname}`} rel='noreferrer'>
			<div>Switch to new version</div>
			<YellowRightArrow />
		</StyledLink>)
	},
	{},
	/*{
		name: 'Kasse live',
		link: '',
		icon: icons.Terminal
	}, {
		name: 'Hilfe',
		link: 'hilfe',
		icon: icons.CustomerSupport
	}, {
		name: 'Info',
		link: 'info',
		icon: icons.Info
	},*/ {
		name: t('common.buttons.logout'),
		className: 'bottomnav-logout',
		action: signOut,
		icon: icons.Logout
	}
]

export const getMainSectionsRegexp = sections => sections.map(({ link }) => link).join('|')
// export const getMainNavContent = (sections, t) => sections.map(({ label, icon, link, NavComponent, linkDisabled, NavAction }) => ({ name: label, icon, link, Component: NavComponent, disabled: linkDisabled, action: NavAction }))
// Temporary workaround to show Kassabuch section only for some customers till all customers DB will be updated
export const getMainNavContent = (sections, t, companyName) => sections.reduce((outArr, { label, icon, link, NavComponent, linkDisabled, withDropDown, NavAction }) => {
	outArr.push({ name: label, icon, link, Component: NavComponent, disabled: linkDisabled, withDropDown, action: NavAction })
	return outArr
}, [])

export default (t, rights, i18n) => sectionsFuncArray.map(section => section(t, rights, i18n))
